import {DAYS, getWeekDays, isTimeAllDay, setTimeByString} from "../../../Common/Date/DateHelper";
import StringHelper from "../../../Common/StringHelper";
import {ConfigHoursApi, GroupedHours} from "../../../Api/types";
import {TFunction} from "i18next";

class HoursHelper {

    static getTime = (i: any) => {
        return (i >= 24) ? "00" : (i < 10) ? "0" + i : i;
    }

    static sortOpenHours = (hours: any) => {
        let weekDays = getWeekDays();
        return [...hours].sort((a: any, b: any) => weekDays.indexOf(a.day_from.toLowerCase()) - weekDays.indexOf(b.day_from.toLowerCase()));
    }

    static isMinuteAvailable = (i: any, minHours: any, maxHours: any, minMinutes: any, maxMinutes: any, time: any) => {
        if (i !== minHours && i !== maxHours) {
            return true;
        }
        if (i === minHours && minMinutes > time) {
            return false;
        }
        if (i === maxHours && maxMinutes < time) {
            return false;
        }
        return true;
    }

    static getDayOfWeekNumber = (dayOfWeek: any) => {
        let weekday = StringHelper.getWeekday();
        var index = weekday.indexOf(dayOfWeek.toLowerCase());
        return index;
    }

    static getOpenHours = (hours: any, date: any) => {
        if (hours === undefined) {
            return undefined;
        }
        var d = date;
        let dayOfWeekIndex = d.getDay();
        let currentHours = [] as any[];
        const sortedHours = [...hours].sort((a, b) => {
            const [ha, ma] = a.hour_from.split(':').map(Number);
            const [hb, mb] = b.hour_from.split(':').map(Number);

            return ha * 60 + ma - (hb * 60 + mb);
        });

        sortedHours.forEach((hourItem: any) => {
            let dayFromIndex = this.getDayOfWeekNumber(hourItem.day_from);
            let dayToIndex = this.getDayOfWeekNumber(hourItem.day_to);
            let hourFrom = hourItem.hour_from;
            let hourTo = hourItem.hour_to;
            if (hourFrom > hourTo) {
                if (dayOfWeekIndex === 0) {
                    if (dayToIndex === 7) {
                        let newHourTo = "00:00";
                        if (newHourTo != hourTo) {
                            currentHours.push({
                                hour_from: newHourTo,
                                hour_to: hourTo,
                            });
                        }
                    }
                    // hourTo = "24:00";
                } else {
                    if (dayToIndex === dayOfWeekIndex - 1) {
                        let newHourTo = "00:00";
                        if (newHourTo != hourTo) {
                            currentHours.push({
                                hour_from: newHourTo,
                                hour_to: hourTo,
                            })
                        }
                    }
                    // hourTo = "24:00";
                }
            }
            if (dayOfWeekIndex >= dayFromIndex && dayOfWeekIndex <= dayToIndex) {
                currentHours.push({
                    hour_from: hourFrom,
                    hour_to: hourTo,
                })
            }
        });
        return currentHours
    }

    static isOpen = (openHours: any, date: any, compareDateToOrEquals?: boolean) => {
        let dayOpenHours = this.getOpenHours(openHours, date);
        if (!dayOpenHours) return false;
        openHours = dayOpenHours.filter(
            openHour => {
                let hourFrom = openHour.hour_from;
                let hourTo = openHour.hour_to;
                if (isTimeAllDay(hourFrom) && isTimeAllDay(hourTo)) {
                    return true;
                }

                var hourFormD = new Date(date.getTime());
                setTimeByString(hourFormD, hourFrom);
                // hourFormD.setHours(hourFrom.substring(0, 2), hourFrom.substring(3, 5),0); // 5.30 pm
                var hourToD = new Date(date.getTime());
                if (hourFrom > hourTo) {
                    hourToD.setDate(hourToD.getDate() + 1);
                }
                setTimeByString(hourToD, hourTo);
                // hourToD.setHours(hourTo.substring(0, 2), hourTo.substring(3, 5),0); // 6.30 pm

                if (date >= hourFormD && (compareDateToOrEquals ? date <= hourToD : date < hourToD)) {
                    return true;
                } else {
                    return false;
                }
            }
        );
        if (openHours.length === 0) {
            return false;
        }
        return true;
    }

    static timeToMinutes = (time: string) => {
        const [h, m] = time.split(":").map(Number);
        return h * 60 + m;
    };

    static minutesToTime = (minutes: number): string => {
        const h = Math.floor(minutes / 60);
        const m = minutes % 60;
        return `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
    };

    static getNextOpening(hours: ConfigHoursApi[], now: Date, t: TFunction): string {
        const currentDayIndex = now.getDay();
        const currentTimeInMinutes = now.getHours() * 60 + now.getMinutes();

        const openNow = hours.find(h => {
            const dayIndex = DAYS.indexOf(h.day_from);
            const startMinutes = HoursHelper.timeToMinutes(h.hour_from);
            let endMinutes = HoursHelper.timeToMinutes(h.hour_to);

            if (h.hour_to === "00:00") endMinutes = 24 * 60;

            if (isTimeAllDay(h.hour_from) && (isTimeAllDay(h.hour_to) || h.hour_to === "23:59" || h.hour_to === "24:00")) {
                return dayIndex === currentDayIndex;
            }

            if (dayIndex !== currentDayIndex) return false;

            if (startMinutes < endMinutes) {
                return currentTimeInMinutes >= startMinutes && currentTimeInMinutes < endMinutes;
            }
            return currentTimeInMinutes >= startMinutes || currentTimeInMinutes < endMinutes;
        });

        if (openNow) {
            if (isTimeAllDay(openNow.hour_from) && (isTimeAllDay(openNow.hour_to) || openNow.hour_to === "23:59" || openNow.hour_to === "24:00")) {
                return t("common.word.open_whole_day");
            }
            return t("common.word.open_to", {time: openNow.hour_to});
        }

        let closestOpening: { date: Date; time: string } | null = null;

        for (let i = 0; i < 7; i++) {
            const checkDate = new Date(now);
            checkDate.setDate(now.getDate() + i);
            const checkDayIndex = checkDate.getDay();

            const dayHours = hours.filter(h => DAYS.indexOf(h.day_from) === checkDayIndex);

            for (const h of dayHours) {
                const [hour, minute] = h.hour_from.split(":").map(Number);
                const openingDate = new Date(now);
                openingDate.setDate(now.getDate() + i);
                openingDate.setHours(hour, minute, 0, 0);

                if (openingDate <= now) continue;

                if (!closestOpening || openingDate < closestOpening.date) {
                    closestOpening = {date: openingDate, time: h.hour_from};
                }
            }
        }

        if (!closestOpening) return t("enums.store_status.closed");

        const nowDateOnly = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const openingDateOnly = new Date(closestOpening.date.getFullYear(), closestOpening.date.getMonth(), closestOpening.date.getDate());

        const diffDays = (openingDateOnly.getTime() - nowDateOnly.getTime()) / (1000 * 60 * 60 * 24);

        if (diffDays === 0) return t("common.word.open_today_at", {time: closestOpening.time});
        if (diffDays === 1) return t("common.word.open_tomorrow_at", {time: closestOpening.time});

        const day = closestOpening.date.getDate().toString().padStart(2, "0");
        const month = (closestOpening.date.getMonth() + 1).toString().padStart(2, "0");

        return t("common.word.open_at", {date: `${day}.${month}`, time: closestOpening.time});
    }

    static hourRangeOverlaps = (a_start: string, a_end: string, b_start: string, b_end: string) => {
        const finalAEnd = a_end === "00:00" ? "24:00" : a_end;
        const finalBEnd = b_end === "00:00" ? "24:00" : b_end;

        if (a_start <= b_start && b_start <= finalAEnd) return true;
        if (a_start <= finalBEnd && finalBEnd <= finalAEnd) return true;
        if (b_start < a_start && finalAEnd < finalBEnd) return true;
        return false;
    }

    static getOpenHoursGroupedByWeekday(hours: ConfigHoursApi[]): GroupedHours {
        const sortedHours = this.sortOpenHours(hours);

        return sortedHours.reduce<GroupedHours>((acc, cur) => {
            const day = cur.day_from;
            if (!acc[day]) {
                acc[day] = [];
            }

            acc[day].push({
                hour_from: cur.hour_from,
                hour_to: cur.hour_to,
                day_to: cur.day_to,
                day_from: cur.day_from,
            });
            return acc;
        }, {})
    }

    static getMergedHourRanges(hours: ConfigHoursApi[]): ConfigHoursApi[] {
        if (hours.length === 0) return [];

        if (hours.some(h => isTimeAllDay(h.hour_from) && isTimeAllDay(h.hour_to))) {
            return [{hour_from: "00:00", hour_to: "00:00", day_from: hours[0].day_from, day_to: hours[0].day_to}];
        }

        const sorted = [...hours].sort((a, b) => a.hour_from.localeCompare(b.hour_from));
        const merged: ConfigHoursApi[] = [sorted[0]];

        for (let i = 1; i < sorted.length; i++) {
            const last = merged[merged.length - 1];
            const current = sorted[i];

            if (this.hourRangeOverlaps(last.hour_from, last.hour_to, current.hour_from, current.hour_to)) {
                last.hour_from = last.hour_from < current.hour_from ? last.hour_from : current.hour_from;
                last.hour_to = last.hour_to > current.hour_to ? last.hour_to : current.hour_to;
            } else {
                merged.push(current);
            }
        }

        return merged;
    }

    static trimHoursToStore(storeOpenHours: ConfigHoursApi[], date: any) {
        const storeFromHours = HoursHelper.getOpenHours(storeOpenHours, date.dateFrom)
            ?.map((h: any) => (h.hour_from))
            .sort((a: any, b: any) => a - b);
        const smallestStoreHour = storeFromHours?.[0];
        const storeToHours = HoursHelper.getOpenHours(storeOpenHours, date.dateFrom)
            ?.map((h: any) => (h.hour_to))
            .sort((a: any, b: any) => b - a);
        const largestStoreHour = storeToHours?.[0];
        const fullDay = isTimeAllDay(date.dateFrom) && isTimeAllDay(date.dateTo);

        if (!HoursHelper.isOpen(storeOpenHours, date.dateFrom)) {
            if (smallestStoreHour) {
                const hour = smallestStoreHour.split(':')[0];
                const minute = smallestStoreHour.split(':')[1];
                const compareDate = new Date(date.dateFrom);
                compareDate.setHours(hour, minute, 0, 0);
                if (date.dateFrom < compareDate || fullDay) {
                    date.dateFrom.setHours(hour, minute, 0, 0);
                    if (fullDay) {
                        date.dateTo.setDate(date.dateFrom.getDate() - 1);
                    }
                }
            }
        }

        if (largestStoreHour) {
            const hour = largestStoreHour.split(':')[0];
            const minute = largestStoreHour.split(':')[1];

            if (!date.dateTo) {
                date.dateTo = new Date(date.dateFrom);
                date.dateTo.setHours(hour, minute, 0, 0);
            } else {
                const compareDate = new Date(date.dateTo);
                compareDate.setHours(hour, minute, 0, 0);
                if (date.dateTo > compareDate || fullDay) {
                    date.dateTo.setHours(hour, minute, 0, 0);
                }
            }
        }
    };
}

export default HoursHelper;